
/**
 * 練習・試合関連のコンディションの選択肢
 */
export const practiceConditionOptions = [
  {value: 'fatigueLevel', label: '疲労度', fullLabel: '疲労度', unit: '10段階'},
  {value: 'satisfactionLevel', label: '充実度', fullLabel: '充実度', unit: '10段階'},
  {value: 'motivationLevel', label: 'モチベ', fullLabel: 'モチベーション', unit: '10段階'},
]

/**
 * 体調関連のコンディションの選択肢
 */
export const bodyConditionOptions = [
  {value: 'healthStatus', label: '体調', fullLabel: '体調', unit: '10段階'},
  {value: 'sleepHours', label: '睡眠', fullLabel: '睡眠', unit: '時間'},
  {value: 'bodyTemperature', label: '体温', fullLabel: '体温', unit: '度'},
  {value: 'bodyWeight', label: '体重', fullLabel: '体重', unit: 'kg'},
  {value: 'bodyHeight', label: '身長', fullLabel: '身長', unit: 'cm'},
  {value: 'menstrualRecord', label: '生理', fullLabel: '生理記録', unit: '○日目'},
]

/**
 * 学校・勉強関連のコンディションの選択肢
 */
export const studyConditionOptions = [
  {value: 'schoolLife', label: '学校生活', fullLabel: '学校生活(充実度)', unit: '10段階'},
  {value: 'studyHours', label: '学習', fullLabel: '学習時間', unit: '時間'},
]

/**
 * コンディションの選択肢
 */
export const conditionOptions = [
  {
    title: '練習・試合',
    items: practiceConditionOptions
  },
  {
    title: '体の状態',
    items: bodyConditionOptions
  },
  {
    title: '学校・勉強',
    items: studyConditionOptions
  },
]

/**
 * 連結したコンディションの選択肢
 */
export const allConditionOptions = [...practiceConditionOptions, ...bodyConditionOptions, ...studyConditionOptions]

/**
 * コンディションのvalueの配列
 * 並び替えの際に使用
 * @returns {Array} コンディションのvalueの配列
 */
export const conditionValues = allConditionOptions.map(condition => condition.value)

/**
 * コンディションのvalueをキーとしたラベルのオブジェクト
 * @returns {Object} コンディションのvalueをキーとしたラベルのオブジェクト
 * @example {fatigueLevel: '疲労度', healthStatus: '体調', ...}
 */
export const labelByConditionValue = allConditionOptions.reduce((acc, condition) => {
  acc[condition.value] = condition.label
  return acc
}, {})

/**
 * コンディションのnameとvalueから表示用の値を取得
 * @param {string} name コンディションのkey(fatigueLevelやhealthStatusなど)
 * @param {string} value コンディションの値
 * @returns {string} 表示用の値
 */
export const getConditionValueWithUnit = (name, value) => {
  // 入力されていない場合は「未入力」を返す
  if (value == null) return '未入力'

  // それぞれ単位が必要なものは単位を付けて返す
  if (name === 'bodyTemperature') {
    return `${value}度`
  }
  if (name === 'bodyWeight') {
    return `${value}kg`
  }
  if (name === 'bodyHeight') {
    return `${value}cm`
  }
  if (name === 'menstrualRecord') {
    return value === 0 ? 'なし' : `${value}日目`
  }
  // 時間関連は時間と分に分けて返す
  if (['sleepHours', 'studyHours'].includes(name)) {
    const [hour, minute] = value.split(':')
    return minute === '00' ? `${hour}時間` : `${hour}時間${minute}分`
  }
  // そのほか10段階のものは単位が不要なのでそのまま返す
  return value || '休み'
}